<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <!--  v-if="backRole('SM_2')" -->
        <el-button type="primary" @click="addPayTypeBtnClick()" size="mini">新增款项类别</el-button>
      </div>
    </div>
    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column type="index" label="序号" align="left" width="100">
      </el-table-column>
      <!-- <el-table-column prop="code" label="代码">
      </el-table-column> -->
      <el-table-column prop="name" label="款项类别" align="left">
      </el-table-column>
      <el-table-column label="操作" width="200" align="right">
        <template slot-scope="scope">

          <el-tooltip class="item" v-if="scope.$index!=0" effect="dark" content="上移该条目" placement="bottom">
            <i class="iconfont icon-shangyimian meeting-btn-icon mbi-move" @click="movePayTypeBtnClick(scope.row, 0)"></i>
          </el-tooltip>
          <el-tooltip class="item" v-if="scope.$index<(paginationData.length-1)" effect="dark" content="下移该条目"
            placement="bottom">
            <i class="iconfont icon-xiayimian meeting-btn-icon mbi-move" @click="movePayTypeBtnClick(scope.row, 1)"></i>
          </el-tooltip>

          <span v-else class="meeting-btn-icon empty-icon"></span>

          <el-tooltip class="item" effect="dark" content="编辑款项类别" placement="bottom">
            <i class="iconfont icon-xiugai meeting-btn-icon mbi-edit" @click="editPayTypeBtnClick(scope.row)"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除款项类别" placement="bottom">
            <i class="iconfont icon-close meeting-btn-icon mbi-remove" @click="deletePayType(scope.row)"></i>
          </el-tooltip>
        </template>
      </el-table-column>

    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length" @current-change="handleCurrentChange">
    </el-pagination>

    <!-- 添加款项支付类型 -->
    <div class="pop-room" v-if="addPayTypeStatus">
      <a href="javascript:;" @click="addPayTypeStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="form" :model="form" label-width="120px" class="form">
            <el-form-item label="款项类别">
              <el-input size="small" v-model="form.name" @keyup.enter.native="submitPayType()"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-button @click="submitPayType()" class="form-btn" type="success">确认提交</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  export default {
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        addPayTypeStatus: false,
        isEdit: false,
        form: {
          name: ""
        },

        // 列表
        loading: true,
        pageSize: 50,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
      }
    },
    mounted() {
      this.getLists()
    },
    components: {},
    methods: {
      // 新增款项支付类型按钮点击
      addPayTypeBtnClick() {
        this.addPayTypeStatus = true
        this.form.name = ""
        this.isEdit = false
      },
      // 编辑款项类别按钮点击
      editPayTypeBtnClick(row) {
        this.addPayTypeStatus = true
        this.form.name = row.name
        this.form.id = row.id
        this.isEdit = true
      },
      movePayTypeBtnClick(row, type) {
        ajax.post('/pay/type/move', {
          id: row.id,
          type,
        }, (res) => {
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
      // 新增款项类别
      submitPayType() {
        let _url = this.isEdit ? '/pay/type/edit' : '/pay/type/add'
        ajax.post(_url, this.form, (res) => {
          this.addPayTypeStatus = false
          if (!this.isEdit) {
            this.$message.success("添加成功")
          } else {
            this.$message.success("编辑成功")
          }
          this.getLists()
        })
      },
      // 删除款项类别
      deletePayType(row) {
        ajax.post('/pay/type/del', {
          PayTypeId: row.id
        }, (res) => {
          this.$message.success("删除款项类别成功")
          this.getLists()
        })
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选数据
      getFilterData() {
        console.log(this.filterName)
        if (this.filterName) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.name.indexOf(this.filterName) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this.currentPage)
      },
      // 获取列表
      getLists() {
        ajax.get('/pay/type/list', '', (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {

    }
  };
</script>



// WEBPACK FOOTER //
// src/page/pay/payType.vue